export const getButtonParam = (button = {}, defaultText) => {
  const isButtonTextEmpty =
    !button || !Object.prototype.hasOwnProperty.call(button, 'text');
  return {
    ...button,
    ...(isButtonTextEmpty && {
      text: defaultText,
    }),
  };
};
